export const allowedSignCharacters =
  ' ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890\'?\'"!"(%)[#]{@}/&<-+÷×=>®©$€£¥¢:;,.*';
